export const RoleMenu: Record<string, string[]> = {
  full_view: [
    '/home-main',
    '/spriced-home',
    '/user-access',
    '/domain-catalogs'
  ],
  dashboard_view: [
    '/home-main',
    '/spriced-home',
    '/domain-catalogs'
  ],
  
  null_view: ['/home-main'
    
  ]
};

export function normalizeRoute(url: unknown): string {
  const path = String(url ?? '')
    .trim()
    .split(/[?#]/, 1)[0]
    .trim()
    .toLowerCase();
  if (!path) return '/';

  const withLeadingSlash = path.startsWith('/') ? path : `/${path}`;
  const withoutTrailingSlashes = withLeadingSlash.replace(/\/+$/, '');
  return withoutTrailingSlashes || '/';
}
